export const TIPOS_PREGUNTA = [
  { value: 'TEXTO', label: 'Texto' },
  { value: 'NUMERICO', label: 'Numérico' },
  { value: 'FECHA', label: 'Fecha' },
  { value: 'SELECCION', label: 'Selección' },
  { value: 'BOOLEANO', label: 'Booleano' },
];

export const PREGUNTA_TEMPLATE = {
  pregunta: '',
  obligatorio: true,
  orden: 1,
  activo: true,
  tipo_pregunta: 'TEXTO',
  multi_respuesta: false,
  opciones: [],
};

export const OPCION_TEMPLATE = {
  opcion_texto: '',
  orden: 1,
  activo: true,
};
